import { AttributeOptionStringIds } from './../types/project-config';
import { IDKeyTypes,IDManager, ObjID } from "./id-manager";
export class IDRegistry {
  private registry: {
    [key:number]:Array<any>;
  } = {};
  private idMgr!:IDManager;

  constructor(idMgr:IDManager) {
    this.idMgr = idMgr;
  }
  IsEmpty():boolean  {
    return Object.keys(this.registry).length === 0;
  }
  RegisterObject(type:IDKeyTypes,obj:any) {
    if(!!obj.id) {
      this.idMgr.ID(type,obj.id);
    } else {
      obj.id = this.idMgr.ID(type);
    }
    if(!this.registry[type]) {
      this.registry[type] = [];
    }
    this.registry[type][obj.id] = obj;
  }
  RegisterID(id:ObjID,obj:any) {
    const numericID = (typeof id === 'string') ? this.idMgr.FromStringID(id) : id;
    if(numericID < 0) return;
    const type:IDKeyTypes = this.idMgr.IDType(numericID);
    if(!this.registry[type]) {
      this.registry[type] = [];
    }
    this.registry[type][numericID] = obj;
    this.idMgr.ID(type,numericID);
  }
  UnRegisterID(id:ObjID) {
    const numericID = this.idMgr.FromID(id);
    if(numericID < 0) return;
    const type:IDKeyTypes = this.idMgr.IDType(numericID);
    delete this.registry[type][numericID];
  }
  ResetConfigIds() {
    this.registry[IDKeyTypes.PointAttributes] = [];
    this.registry[IDKeyTypes.SegmentAttributes] = [];
    this.registry[IDKeyTypes.SupplementalAttributes] = [];
    this.registry[IDKeyTypes.AttributeOption] = [];
  }
  Get(id:ObjID):any | null {
    const type:IDKeyTypes = this.idMgr.IDType(id);
    const numericID = (typeof id === 'string') ? this.idMgr.FromStringID(id) : id;
    if(this.registry[type]) {
      return this.registry[type][numericID];
    }
    return null;
  }
  GetByType(type:IDKeyTypes,id?:ObjID):any | undefined {
    if(!this.registry[type]) return undefined;
    const registry = this.registry[type] as any;
    if(!id) return registry;
    const item = registry[id];
    return !!item ? item : undefined;
  }
}
